import { Component, OnInit } from '@angular/core';

import * as firebase from 'firebase';

@Component({
  selector: 'app-send-notification',
  templateUrl: './send-notification.component.html',
  styleUrls: ['./send-notification.component.css']
})
export class SendNotificationComponent implements OnInit {

  notification: any = {};

  loading: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  send() {
    if (!this.notification.title) {
      return alert("Please enter title");
    }

    if (!this.notification.text) {
      return alert("Please enter message");
    }

    this.loading = true;

    this.notification.timestamp = Number(new Date());

    firebase.database().ref("adminNotifications").push(this.notification);

    this.sendNotification();
  }

  sendNotification() {
    var func = firebase.functions().httpsCallable('sendNotification');

    func({
      title: this.notification.title,
      message: this.notification.text,
      topic: "all"
    })
      .then(() => {
        alert("Notification sent to all users.");
        this.notification = {};
        this.loading = false;
      });
  }

}
